import { useCurrentUserQuery } from "generated/graphql";

const useCurrentUser = () => {
  const { data, loading } = useCurrentUserQuery();

  return !loading && data && data.currentUser ? data.currentUser : null;
};

export default useCurrentUser;
